<template>
  <label
    :class="{
      'size-large': size === 'large',
      'size-medium': size === 'medium',
      'size-small': size === 'small'
    }"
    :for="name"
  >
    <slot /><span v-if="required">(required)</span>
  </label>
</template>

<script>
export default {
  name: "DoeLabel",
  props: {
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium",
      validator: value => {
        return ["large", "medium", "small"].indexOf(value) !== -1;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  @apply block font-light font-sans leading-snug mb-1 subpixel-antialiased text-xl text-black w-full;
}
.size-large {
  @apply font-bold text-xl;
}
.size-medium {
  @apply text-xl;
}
.size-small {
  @apply text-base;
}
</style>
